var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M16 0c8.825 0 16 7.175 16 16s-7.175 16-16 16S0 24.825 0 16 7.175 0 16 0zm0 1.954C8.253 1.954 1.954 8.253 1.954 16c0 7.747 6.299 14.046 14.046 14.046 7.747 0 14.046-6.299 14.046-14.046 0-7.747-6.299-14.046-14.046-14.046zm6.864 9.406c.52-.48 1.285-.48 1.772 0 .485.482.485 1.272 0 1.752l-10.63 10.51c-.243.241-.555.378-.903.378-.347 0-.66-.138-.903-.378l-5.836-5.77c-.485-.482-.485-1.272 0-1.752.487-.48 1.286-.48 1.772 0l4.967 4.911z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.fedb6850.svg";
export { ForwardRef as ReactComponent };